import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { studentsWrapperCreatePost } from '../../../../api-client/api-gqadmin-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const postStudentsWrapperCreate = createAsyncThunk(
    'postStudentsWrapperCreate/Post',
    async (body, { rejectWithValue }) => {
        try {
            const response = await studentsWrapperCreatePost(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'POST_GQ_ADMIN_STUDENT_WRAPPER_CREATE_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const postStudentsWrapperCreateSlice = createSlice({
    name: 'postStudentsWrapperCreate',
    initialState,
    extraReducers: {
        [postStudentsWrapperCreate.pending]: (state) => {
            state.loading = true;
        },
        [postStudentsWrapperCreate.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [postStudentsWrapperCreate.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const postStudentsWrapperCreateSelector = (state) => state.postStudentsWrapperCreate;
export const postStudentsWrapperCreateReducer = postStudentsWrapperCreateSlice.reducer;
